export function redesign() {
  switch (process.env.VUE_APP_BRAND) {
    case "oldmutual":
    case "teba":
      return true;
    case "quickwill":
      return false;
    default:
      false;
  }
}

export function landingPages() {
  switch (process.env.VUE_APP_BRAND) {
    case "oldmutual":
      return true;
    case "teba":
    case "quickwill":
      return false;
    default:
      false;
  }
}
